import React, {Component} from 'react';
const { connect } = require('react-redux');

import 'sass/member/MemberPhotos.scss';

import Footer from '../../components/Footer';
import HeaderMemberPhotos from 'components/member/HeaderMemberPhotos';
import ModalAddPhoto from 'components/modals/ModalAddPhoto';

import {getMemberPhotos} from 'reducers/memberPhotos';
import {openMemberPhoto} from 'reducers/memberPhoto';

import {t} from 'l10n';
import {ALBUM_CERTIFIED, ALBUM_PUBLIC, ALBUM_XXL} from '../../constants/memberPhoto';

class MemberPhotos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            openedMemberPhoto: null
        }
    }

    componentDidMount() {
        this.props.getMemberPhotos();
    }

    render() {
        let {memberPhotos} = this.props;

        let editFn = (memberPhoto) => this.setState({openedMemberPhoto: memberPhoto, showModal: true});

        return (
            <div id="wrapper">
                <HeaderMemberPhotos/>

                <ModalAddPhoto
                    show={this.state.showModal}
                    memberPhoto={this.state.openedMemberPhoto}
                    closeFn={() => this.setState({openedMemberPhoto: null, showModal: false})}
                />

                <aside className="myphotos">
                    <div className="content">
                        {memberPhotos[ALBUM_PUBLIC] && <AlbumBlock type={ALBUM_PUBLIC} photos={memberPhotos[ALBUM_PUBLIC]} editFn={editFn}/>}

                        {memberPhotos[ALBUM_XXL] && <AlbumBlock type={ALBUM_XXL} photos={memberPhotos[ALBUM_XXL]} editFn={editFn}/>}

                        {memberPhotos[ALBUM_CERTIFIED] && <AlbumBlock type={ALBUM_CERTIFIED} photos={memberPhotos[ALBUM_CERTIFIED]} editFn={editFn}/>}
                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

import MemberPhotoList from 'components/list/MemberPhotoList';

const blockHeaders = {
    [ALBUM_PUBLIC]: t('Public photos'),
    [ALBUM_XXL]: t('XXL photos'),
    [ALBUM_CERTIFIED]: t('Certified photos')
};

function AlbumBlock({type, photos, editFn}) {
    if (!blockHeaders[type]) return null;

    return (
        <div className="album-block">
            <div className="heading">
                <h2>{blockHeaders[type]} <em>{t('%1 of %2', photos.length, photos.length)}</em></h2>
            </div>

            <MemberPhotoList memberPhotos={photos} editFn={editFn}/>
        </div>
    )
}

export default connect(
    state => ({
        memberPhotos: state.memberPhotos
    }),({
        getMemberPhotos: getMemberPhotos
    })
)(MemberPhotos)


// WEBPACK FOOTER //
// ./src/containers/member/MemberPhotos.js